import { MobileMenu } from "./mobileMenu";
import { Modal } from "./Modal";
import { Tab } from "./Tab";
import { semiModal } from "./semiModal";
import { FaceInScroll } from "./FadeInScroll";
import { HomeSlide } from "./HomeSlide";

const init = () => {
  new MobileMenu();
  new Modal();
  new Tab();
  new semiModal();
  new FaceInScroll();
  new HomeSlide();
};

window.addEventListener("DOMContentLoaded", () => {
  init();
});
